import { css } from 'emotion';
import { animationTransition, colors } from '@joykit/variables';

export namespace styles {
  export const designOption = css({
    padding: '24px 0',
    display: 'flex',
    flexDirection: 'column',
    // ':not(:last-child)': {
    borderBottom: `1px solid ${colors.light}`
    // }
  });

  export const designOptionButton = css({
    width: '100%',
    display: 'block',
    color: 'inherit',
    cursor: 'pointer',
    textAlign: 'left',
    background: 'none',
    borderStyle: 'none',
    padding: '0',
    font: 'inherit',
    outline: 'inherit',
    ':not(:last-child)': {
      margin: '0 0 24px 0'
    }
  });

  export const optionTitleContainer = css({
    display: 'flex'
    // flexWrap: 'wrap'
  });

  export const chevron = (open: boolean) =>
    css({
      height: 15,
      width: 15,
      alignSelf: 'center',
      transition: animationTransition('transform'),
      transform: open ? 'rotate(180deg)' : undefined,
      flexShrink: 0
    });

  export const optionTitle = css({
    overflowWrap: 'break-word',
    fontSize: '15px',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
    color: 'rgb(72, 72, 72)',
    fontWeight: 800,
    flexGrow: 1,
    margin: '0px',
    marginBottom: 4
  });

  export const optionSubtitle = css({
    overflowWrap: 'break-word',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: 'normal',
    fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
    fontWeight: 'normal',
    color: 'rgb(118, 118, 118)',
    margin: '0px'
  });

  export const optionContent = (visible: boolean) =>
    css({
      // height: 0,
      transition: animationTransition('height')
    });
}
